import dynamic from "next/dynamic";

import { BrandSelections } from "@brexhq/shared/types/Brands";

//FIXME: This uses next/dynamic and should live in /next, but Sanity currently uses it to render Icons.
const allBrandIcons: Record<typeof BrandSelections[number], any> = {
  AirFranceKlm: dynamic(
    () => import("@brexhq/shared/assets/icons/brand/AirFranceKlm"),
  ),
  Airbnb: dynamic(() => import("@brexhq/shared/assets/icons/brand/Airbnb")),
  Algolia: dynamic(() => import("@brexhq/shared/assets/icons/brand/Algolia")),
  AmourVert: dynamic(
    () => import("@brexhq/shared/assets/icons/brand/AmourVert"),
  ),
  Andie: dynamic(() => import("@brexhq/shared/assets/icons/brand/Andie")),
  AppStore: dynamic(() => import("@brexhq/shared/assets/icons/brand/AppStore")),
  Apple: dynamic(() => import("@brexhq/shared/assets/icons/brand/Apple")),
  AsiaMiles: dynamic(
    () => import("@brexhq/shared/assets/icons/brand/AsiaMiles"),
  ),
  AthleticGreens: dynamic(
    () => import("@brexhq/shared/assets/icons/brand/AthleticGreens"),
  ),
  Avianca: dynamic(() => import("@brexhq/shared/assets/icons/brand/Avianca")),
  Babylist: dynamic(() => import("@brexhq/shared/assets/icons/brand/Babylist")),
  BillionToOne: dynamic(
    () => import("@brexhq/shared/assets/icons/brand/BillionToOne"),
  ),
  BioBusinessSolutions: dynamic(
    () => import("@brexhq/shared/assets/icons/brand/BioBusinessSolutions"),
  ),
  Blackfynn: dynamic(
    () => import("@brexhq/shared/assets/icons/brand/Blackfynn"),
  ),
  Blank: dynamic(() => import("@brexhq/shared/assets/icons/brand/Blank")),
  Boxed: dynamic(() => import("@brexhq/shared/assets/icons/brand/Boxed")),
  BusinessInsider: dynamic(
    () => import("@brexhq/shared/assets/icons/brand/BusinessInsider"),
  ),
  Clsa: dynamic(() => import("@brexhq/shared/assets/icons/brand/Clsa")),
  CNBC: dynamic(() => import("@brexhq/shared/assets/icons/brand/CNBC")),
  CnbcDisruptor: dynamic(
    () => import("@brexhq/shared/assets/icons/brand/CnbcDisruptor"),
  ),
  Carta: dynamic(() => import("@brexhq/shared/assets/icons/brand/Carta")),
  Classpass: dynamic(
    () => import("@brexhq/shared/assets/icons/brand/Classpass"),
  ),
  Clever: dynamic(() => import("@brexhq/shared/assets/icons/brand/Clever")),
  Clora: dynamic(() => import("@brexhq/shared/assets/icons/brand/Clora")),
  ClubPremier: dynamic(
    () => import("@brexhq/shared/assets/icons/brand/ClubPremier"),
  ),
  Concur: dynamic(() => import("@brexhq/shared/assets/icons/brand/Concur")),
  DstGlobal: dynamic(
    () => import("@brexhq/shared/assets/icons/brand/DstGlobal"),
  ),
  Deel: dynamic(() => import("@brexhq/shared/assets/icons/brand/Deel")),
  Doordash: dynamic(() => import("@brexhq/shared/assets/icons/brand/Doordash")),
  DrSquatch: dynamic(
    () => import("@brexhq/shared/assets/icons/brand/DrSquatch"),
  ),
  Dropbox: dynamic(() => import("@brexhq/shared/assets/icons/brand/Dropbox")),
  Expensify: dynamic(
    () => import("@brexhq/shared/assets/icons/brand/Expensify"),
  ),
  Experian: dynamic(() => import("@brexhq/shared/assets/icons/brand/Experian")),
  FastCompany: dynamic(
    () => import("@brexhq/shared/assets/icons/brand/FastCompany"),
  ),
  FirstBase: dynamic(
    () => import("@brexhq/shared/assets/icons/brand/FirstBase"),
  ),
  Flexport: dynamic(() => import("@brexhq/shared/assets/icons/brand/Flexport")),
  Forbes: dynamic(() => import("@brexhq/shared/assets/icons/brand/Forbes")),
  Freshworks: dynamic(
    () => import("@brexhq/shared/assets/icons/brand/Freshworks"),
  ),
  FrogFuel: dynamic(() => import("@brexhq/shared/assets/icons/brand/FrogFuel")),
  GoDaddy: dynamic(() => import("@brexhq/shared/assets/icons/brand/GoDaddy")),
  GoogleAds: dynamic(
    () => import("@brexhq/shared/assets/icons/brand/GoogleAds"),
  ),
  GreenOaks: dynamic(
    () => import("@brexhq/shared/assets/icons/brand/GreenOaks"),
  ),
  Him: dynamic(() => import("@brexhq/shared/assets/icons/brand/Him")),
  Hourly: dynamic(() => import("@brexhq/shared/assets/icons/brand/Hourly")),
  Hubspot: dynamic(() => import("@brexhq/shared/assets/icons/brand/Hubspot")),
  Ivp: dynamic(() => import("@brexhq/shared/assets/icons/brand/Ivp")),
  Intercom: dynamic(() => import("@brexhq/shared/assets/icons/brand/Intercom")),
  JetBlue: dynamic(() => import("@brexhq/shared/assets/icons/brand/JetBlue")),
  Klaviyo: dynamic(() => import("@brexhq/shared/assets/icons/brand/Klaviyo")),
  KleinerPerkins: dynamic(
    () => import("@brexhq/shared/assets/icons/brand/KleinerPerkins"),
  ),
  Kranz: dynamic(() => import("@brexhq/shared/assets/icons/brand/Kranz")),
  Kruze: dynamic(() => import("@brexhq/shared/assets/icons/brand/Kruze")),
  Lookout: dynamic(() => import("@brexhq/shared/assets/icons/brand/Lookout")),
  Microsoft: dynamic(
    () => import("@brexhq/shared/assets/icons/brand/Microsoft"),
  ),
  Miroculus: dynamic(
    () => import("@brexhq/shared/assets/icons/brand/Miroculus"),
  ),
  Monday: dynamic(() => import("@brexhq/shared/assets/icons/brand/Monday")),
  Mutiny: dynamic(() => import("@brexhq/shared/assets/icons/brand/Mutiny")),
  NetSuite: dynamic(() => import("@brexhq/shared/assets/icons/brand/NetSuite")),
  NewYorkTimes: dynamic(
    () => import("@brexhq/shared/assets/icons/brand/NewYorkTimes"),
  ),
  Op2Labs: dynamic(() => import("@brexhq/shared/assets/icons/brand/Op2Labs")),
  Oracle: dynamic(() => import("@brexhq/shared/assets/icons/brand/Oracle")),
  Othram: dynamic(() => import("@brexhq/shared/assets/icons/brand/Othram")),
  OutdoorVoices: dynamic(
    () => import("@brexhq/shared/assets/icons/brand/OutdoorVoices"),
  ),
  PerfectKeto: dynamic(
    () => import("@brexhq/shared/assets/icons/brand/PerfectKeto"),
  ),
  Pilot: dynamic(() => import("@brexhq/shared/assets/icons/brand/Pilot")),
  PixelUnion: dynamic(
    () => import("@brexhq/shared/assets/icons/brand/PixelUnion"),
  ),
  Qantas: dynamic(() => import("@brexhq/shared/assets/icons/brand/Qantas")),
  Quartzy: dynamic(() => import("@brexhq/shared/assets/icons/brand/Quartzy")),
  QuickBooks: dynamic(
    () => import("@brexhq/shared/assets/icons/brand/QuickBooks"),
  ),
  Retool: dynamic(() => import("@brexhq/shared/assets/icons/brand/Retool")),
  RibbitCapital: dynamic(
    () => import("@brexhq/shared/assets/icons/brand/RibbitCapital"),
  ),
  Rippling: dynamic(() => import("@brexhq/shared/assets/icons/brand/Rippling")),
  Robinhood: dynamic(
    () => import("@brexhq/shared/assets/icons/brand/Robinhood"),
  ),
  Room: dynamic(() => import("@brexhq/shared/assets/icons/brand/Room")),
  ScaleAi: dynamic(() => import("@brexhq/shared/assets/icons/brand/ScaleAi")),
  Segment: dynamic(() => import("@brexhq/shared/assets/icons/brand/Segment")),
  Shippo: dynamic(() => import("@brexhq/shared/assets/icons/brand/Shippo")),
  SingaporeAirlines: dynamic(
    () => import("@brexhq/shared/assets/icons/brand/SingaporeAirlines"),
  ),
  Skip: dynamic(() => import("@brexhq/shared/assets/icons/brand/Skip")),
  Snapchat: dynamic(() => import("@brexhq/shared/assets/icons/brand/Snapchat")),
  SoFi: dynamic(() => import("@brexhq/shared/assets/icons/brand/SoFi")),
  Soludos: dynamic(() => import("@brexhq/shared/assets/icons/brand/Soludos")),
  Sonoma: dynamic(() => import("@brexhq/shared/assets/icons/brand/Sonoma")),
  SonomaPharma: dynamic(
    () => import("@brexhq/shared/assets/icons/brand/SonomaPharma"),
  ),
  SpiralTherapeutics: dynamic(
    () => import("@brexhq/shared/assets/icons/brand/SpiralTherapeutics"),
  ),
  Spreadsheet: dynamic(
    () => import("@brexhq/shared/assets/icons/brand/Spreadsheet"),
  ),
  Stable: dynamic(() => import("@brexhq/shared/assets/icons/brand/Stable")),
  StitchLabs: dynamic(
    () => import("@brexhq/shared/assets/icons/brand/StitchLabs"),
  ),
  Superhuman: dynamic(
    () => import("@brexhq/shared/assets/icons/brand/Superhuman"),
  ),
  TechCrunch: dynamic(
    () => import("@brexhq/shared/assets/icons/brand/TechCrunch"),
  ),
  Trinet: dynamic(() => import("@brexhq/shared/assets/icons/brand/Trinet")),
  TheInformation: dynamic(
    () => import("@brexhq/shared/assets/icons/brand/TheInfromation"),
  ),
  Union: dynamic(() => import("@brexhq/shared/assets/icons/brand/Union")),
  UntuckIt: dynamic(() => import("@brexhq/shared/assets/icons/brand/UntuckIt")),
  Ups: dynamic(() => import("@brexhq/shared/assets/icons/brand/Ups")),
  VizAi: dynamic(() => import("@brexhq/shared/assets/icons/brand/VizAi")),
  Vouch: dynamic(() => import("@brexhq/shared/assets/icons/brand/Vouch")),
  Wag: dynamic(() => import("@brexhq/shared/assets/icons/brand/Wag")),
  Xero: dynamic(() => import("@brexhq/shared/assets/icons/brand/Xero")),
  YCombinator: dynamic(
    () => import("@brexhq/shared/assets/icons/brand/YCombinator"),
  ),
  Yotpo: dynamic(() => import("@brexhq/shared/assets/icons/brand/Yotpo")),
  Zoom: dynamic(() => import("@brexhq/shared/assets/icons/brand/Zoom")),
  Aws: dynamic(() => import("@brexhq/shared/assets/icons/brand/Aws")),
  Bio: dynamic(() => import("@brexhq/shared/assets/icons/brand/Bio")),
  Bounce: dynamic(() => import("@brexhq/shared/assets/icons/brand/Bounce")),
  Broker: dynamic(() => import("@brexhq/shared/assets/icons/brand/Broker")),
  Gusto: dynamic(() => import("@brexhq/shared/assets/icons/brand/Gusto")),
  Hims: dynamic(() => import("@brexhq/shared/assets/icons/brand/Hims")),
  Numi: dynamic(() => import("@brexhq/shared/assets/icons/brand/Numi")),
  Slack: dynamic(() => import("@brexhq/shared/assets/icons/brand/Slack")),
  Spiral: dynamic(() => import("@brexhq/shared/assets/icons/brand/Spiral")),
  Tiled: dynamic(() => import("@brexhq/shared/assets/icons/brand/Tiled")),
  Twilio: dynamic(() => import("@brexhq/shared/assets/icons/brand/Twilio")),
  Usual: dynamic(() => import("@brexhq/shared/assets/icons/brand/Usual")),
  Vouched: dynamic(() => import("@brexhq/shared/assets/icons/brand/Vouched")),
  ZDNet: dynamic(() => import("@brexhq/shared/assets/icons/brand/ZDNet")),
  Airtable: dynamic(() => import("@brexhq/shared/assets/icons/brand/Airtable")),
};

export default allBrandIcons;
